var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleConductor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 35,
    height: 25,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANEAAAApCAYAAACr+8ybAAAAzElEQVR4nO3c0Q2CMBRA0da4DftvAvPglwt4Y2zjOROQwqV89DHP87wH8LGHpYNGRBCJCCIRQSQiiEQEkYggEhFEIoJIRBA9V1zA4zgWuAp+7bquLe6BnYhl7fIyFRFEIoJIRBCJCCIRQTTHGEtOtt63gdt/N+fcYgXsRBCJCCIRQbTk334c++Fth6M/diKIRASRiCASEUQigkhEEC0Z0S4TjXzXLs/BkuPhQ0hsxOccRCKCSEQQiQgiEUEkIohEBJGIIBIRRCKCYozxAsygGUcvz5sEAAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleConductor);
export default __webpack_public_path__ + "static/media/SingleConductor.313555abea0ad3671bc9391f2442dc18.svg";
export { ForwardRef as ReactComponent };